import { constants } from '../../helpers';
import { DateRangeFlexSalesProps } from '../DateRangeFlexSales';
import ReportOperationDateRangeFilter from '../ReportFilters/filters/OperationDateRangeFilter';

type OperationDateRangeFilterProps = Pick<DateRangeFlexSalesProps<Date>, 'spacing'> & {
  maxDaysBetween?: number;
  requiredIncomplete?: boolean;
};

const OperationDateRangeFilter = (props: OperationDateRangeFilterProps) => (
  <ReportOperationDateRangeFilter {...props} maxDate={constants.reportGcsFilterRangeMaxDate} />
);

export default OperationDateRangeFilter;
